<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <div>
      <!-- <b-card>
      <b-row>
        <b-col md="10">
          <b-form-group
            label="ยูเซอร์ไอดี"
            label-for="customDelimiter"
          >
            <v-select
              v-model="search_userID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="names"
              :options="userslist"
              :reduce="(username) => username.username"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          class="p-0"
          style="margin-top: 20px"
        >
          <b-button
            block
            variant="gradient-dark"
            @click="
              $router.push({
                name: 'Deposit-Withdraw',
                params: { id: search_userID },
              }),
              changeUserEdit()
            "
          >
            <i class="far fa-sparkles" />
            ค้นหาข้อมูล
          </b-button>
        </b-col>
      </b-row>
    </b-card> -->

      <b-row>
        <b-col md="9">
          <b-card>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h4><i class="fa fa-users" /> แก้ไขข้อมูลลูกค้า</h4>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="username">ค้นหายูสลูกค้า</label>
                      <input
                        id="username"
                        v-model="search_user"
                        type="text"
                        class="form-control"
                        placeholder="ค้นหาด้วยเบอร์โทร ยูสเซอร์เนม"
                        @keyup.enter="searchuser()"
                      >
                    </div>
                  </div>
                  <div class="col-md-6 d-flex align-items-end">
                    <div class="form-group mr-2">
                      <button
                        class="btn btn-gradient-dark"
                        @click="searchuser()"
                      >
                        <feather-icon icon="SearchIcon" />
                        ค้นหา
                      </button>
                    </div>
                    <!-- <div class="form-group mr-2">
                      <b-button
                        v-b-modal.modal-deposit
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="gradient-primary"
                      >
                        เติมเครดิต
                      </b-button>
                    </div>
                    <div class="form-group mr-2">
                      <b-button
                        v-b-modal.modal-4
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="gradient-success"
                        block
                        @click="tel = '',qrCodeResult=null,autoSlipAcc=null,search = false,qrCodeStatus = true"
                      >
                        เติมเครดิตด้วยสลิป
                      </b-button>
                    </div> -->
                    <div class="form-group mr-2">
                      <b-button
                        v-b-modal.modal-holdcredit
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="gradient-danger"
                      >
                        ตัดเครดิตทั้งหมด
                      </b-button>
                    </div>
                    <div class="form-group">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="gradient-info"
                        @click="copyuserdata()"
                      >
                        คัดลอกข้อมูล
                      </b-button>
                    </div>
                  </div>
                </div>

                <div>
                <!-- <b-col
              v-if="UserData.userID === 20"
              md="2"
              class="p-0"
              style="margin-top: 20px"
            >
              <b-form-input
                id="floating-label2"
                v-model="Edittelz"
                type="text"
                placeholder=""
              />
              <b-button
                block
                variant="gradient-dark"
                @click="Edittel(Edittelz)"
              >
                <i class="far fa-sparkles" />
                แก้ไขเบอร์โทร
              </b-button>
            </b-col> -->

                <!-- <div>
              <a
                class="btn btn-gradient-info mr-1"
                href="#deposit"
              >
                <i class="fas fa-arrow-up" /> ประวัติการฝาก
              </a>
              <a
                class="btn btn-gradient-info mr-1"
                href="#withdraw"
              >
                <i class="fas fa-arrow-down" /> ประวัติการถอน
              </a>
              <a
                class="btn btn-gradient-info mr-1"
                href="#play"
              >
                <i class="fas fa-magic" /> ประวัติการเล่น
              </a>
              <a
                class="btn btn-gradient-info text-white"
                @click="cancel"
              >
                <i class="fas fa-users" /> เพื่อนที่แนะนำ
              </a>
            </div> -->
                </div>
                <hr class="m-0 p-0">
                <!-- <h4><i class="fas fa-user-edit" /> แก้ไขข้อมูลลูกค้า</h4> -->
                <b-row class="mt-1">
                  <b-col md="6">
                    <b-form-group>
                      <label>ชื่อ <small class="text-danger">*</small></label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.name"
                        type="text"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label>นามสกุล <small class="text-danger">*</small></label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.surname"
                        type="text"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label>เบอร์โทรศัพท์</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.tel"
                        type="text"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>
                  <!-- :disabled="UserData.role === 'super admin' ? false : true" -->
                  <b-col md="6">
                    <b-form-group>
                      <label>รหัสผ่าน</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.passwords"
                        type="text"
                        maxlength="6"
                        placeholder="กรอกตัวเลขเท่านั้น"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label>ธนาคาร</label>
                      <v-select
                        v-model="userDetails.bank"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="banklist"
                        :reduce="(name) => name.bankcode"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label>เลขที่บัญชี</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.acc_no"
                        type="number"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>
                  <!-- <b-col md="12">
                    <b-form-group>
                      <label>ธนาคารเกาหลี</label>
                      <v-select
                        v-model="userDetails.bank_kr"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="banklist_kr"
                        :reduce="(name) => name.code"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label>เลขที่บัญชีเกาหลี</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.accno_kr"
                        type="number"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col> -->
                  <!-- <b-col
              md="1"
              class="p-0"
              style="margin-top: 23px"
            >
              <b-form-group>
                <b-button
                  block
                  variant="gradient-primary"
                  @click="CheckName(userDetails.acc_no)"
                >
                  เช็คชื่อ
                </b-button>
              </b-form-group>
            </b-col> -->
                  <b-col md="6">
                    <b-form-group>
                      <label>เบอร์ Truemoney Wallet</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.trueaccno"
                        type="number"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label>UID Peer2pay</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.p2p_uid"
                        type="number"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label>สถานะลูกค้า</label>
                      <b-form-select
                        v-model="userDetails.status"
                        :options="options"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group>
                      <label>Line ID</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="userDetails.line_id"
                        type="text"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="เลือกผู้แนะนำ"
                      label-for="customDelimiter"
                    >
                      <b-overlay
                        :show="optionsMemShow"
                        variant="transparent"
                        opacity="0.99"
                        blur="5px"
                        rounded="sm"
                      >
                        <template #overlay>
                          <div class="text-center">
                            <b-icon-controller
                              font-scale="2"
                              animation="cylon"
                            />
                          </div>
                        </template>
                        <div class="d-flex">
                          <div
                            v-if="optionsCheck === true"
                            class="m_vs"
                          >
                            <v-select
                              v-model="userDetails.invited_by"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              label="names"
                              :options="optionsMember"
                              :reduce="names => names.invite_code"
                            />
                          </div>
                          <div
                            v-else
                            class="m_vs"
                          >
                            <b-form-input
                              id="floating-label2"
                              v-model="userDetails.invited_by"
                              type="text"
                              placeholder="กรอกชื่อผู้แนะนำ"
                            />
                          </div>
                          <button
                            class="btn btn-outline-primary btn-sm"
                            @click="getUserslist(userDetails.invited_by , 'name')"
                          >
                            ค้นหา
                          </button>
                        </div>
                      </b-overlay>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col md="6">
                    <b-form-group>
                      <label>สกุลเงิน</label>
                      <b-form-select
                        v-model="userDetails.currency"
                        :options="currency_options"
                      />
                    </b-form-group>
                  </b-col> -->

                  <b-col md="6">
                    <b-form-group>
                      <label>Ranking</label>
                      <b-form-input
                        id="floating-label2"
                        v-model="UserRank.level"
                        type="text"
                        placeholder=""
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group>
                      <div class="d-flex align-items-center">
                        <div class="mr-4">
                          <label>สถานะ Blacklist</label>
                          <b-form-checkbox
                            v-model="userDetails.blacklist"
                            class="custom-control-danger"
                            name="check-button"
                            switch
                          >
                            <span class="switch-icon-left">
                              <feather-icon icon="CheckIcon" />
                            </span>
                            <span class="switch-icon-right">
                              <feather-icon icon="XIcon" />
                            </span>
                          </b-form-checkbox>
                        </div>
                        <div
                          v-if="userDetails.blacklist"
                          style="flex-grow: 1;"
                        >
                          <label />
                          <b-form-input
                            id="floating-label2"
                            v-model="userDetails.blacklist_remark"
                            type="text"
                            placeholder="หมายเหตุ"
                            style="width: 41%;"
                          />
                        </div>
                      </div>
                    </b-form-group>

                    <b-form-group>
                      <label>สถานะ VIP</label>
                      <b-form-checkbox
                        v-model="userDetails.vip"
                        checked="true"
                        class="custom-control-info"
                        name="check-button"
                        switch
                      >
                        <span class="switch-icon-left">
                          <feather-icon icon="CheckIcon" />
                        </span>
                        <span class="switch-icon-right">
                          <feather-icon icon="XIcon" />
                        </span>
                      </b-form-checkbox>
                    </b-form-group>
                    <hr>
                  </b-col>

                  <b-col
                    md="12"
                    class="card-warning"
                  >
                    <div class="mt-1">
                      <b-form-group>
                        <label>ตั้งให้เป็นเซียน</label>
                        <b-form-checkbox
                          v-model="userDetails.zean"
                          class="custom-control-success"
                          name="check-button"
                          switch
                        >
                          <span class="switch-icon-left">
                            <feather-icon icon="CheckIcon" />
                          </span>
                          <span class="switch-icon-right">
                            <feather-icon icon="XIcon" />
                          </span>
                        </b-form-checkbox>
                      </b-form-group>

                      <b-form-group>
                        <label>% ที่ให้(สำหรับเซียน) (หากกำหนดตรงนี้เป็น 0
                          จะใช้ค่าที่กำหนดไว้ในระบบ)</label>

                        <b-form-input
                          id="percent"
                          v-model="userDetails.zean_percent"
                          type="number"
                          placeholder=""
                        />
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col
                    md="12"
                    class="mt-1"
                  >
                    <b-form-group>
                      <b-button
                        variant="gradient-dark"
                        block
                        @click="update_member()"
                      >
                        <i class="fas fa-save" />
                        บันทึกข้อมูล
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div></div></b-card>
        </b-col>
        <b-col md="3">
          <div class="card-cradit white mb-1">
            <div class="p-1">
              <span>เครดิตคงเหลือ ({{ currency }})</span>
              <h3>{{ currency === 'THB' ? Commas(balance) : Commas(balance_kr) }}</h3>
            </div>
            <div class="card-b d-flex justify-content-between">
              <small>เพชรคงเหลือ : {{ chip }}</small>
            <!-- <small>เลขที่บัญชี : {{ currency === 'THB' ? userDetails.acc_no : userDetails.accno_kr }}</small> -->
            </div>
          </div>

          <div class="card-cradit-blue white mb-1">
            <div class="p-1">
              <span>ยอดฝาก ({{ currency }})</span>
              <h3>{{ datalist.depamount ? Commas(datalist.depamount) : 0 }}</h3>
            </div>
            <div class="card-b d-flex justify-content-between">
              <small>-</small>
              <small>ฝากทั้งหมด {{ datalist.depamount ? Commas(datalist.depamount) : 0 }}</small>
            </div>
          </div>

          <div class="card-cradit-green white mb-1">
            <div class="p-1">
              <span>ยอดถอน ({{ currency }})</span>
              <h3>{{ datalist.withamount ? Commas(datalist.withamount) : 0 }}</h3>
            </div>
            <div class="card-b d-flex justify-content-between">
              <small>-</small>
              <small>{{ datalist.withamount ? Commas(datalist.withamount) : 0 }}</small>
            </div>
          </div>

          <div class="card-cradit-orange white mb-1">
            <div class="p-1">
              <span>ยอดรวมทั้งหมด ({{ currency }})</span>
              <h3>{{ datalist.total ? Commas(datalist.total) : 0 }}</h3>
            </div>
            <div class="card-b d-flex justify-content-between">
              <small>-</small>
              <small>-</small>
            </div>
          </div>

          <div class="card-cradit-white white mb-1">
            <div class="p-1">
              <div v-if="turn">
                <span>โปรปัจจุบัน</span>
                <hr>
                <div>
                  <small>ชื่อโปรโมชั่น : {{ turn.promotion }}</small><br>
                  <small>ยอดเทิร์นที่ต้องทำ : {{ turn.turnover }}</small><br>
                  <small>ยอดเทิร์นปัจจุบัน : {{ turn.userturnover }}</small><br>
                </div>
                <hr>
              </div>
              <div>
                <b-button
                  v-b-modal.modal-success
                  variant="gradient-primary"
                  block
                  size="sm"
                >
                  <i class="fad fa-history" />
                  ประวัติรับโปร
                </b-button>
              </div><br>
              <div>
                <b-button
                  v-b-modal.modal-rolling
                  variant="gradient-danger"
                  block
                  size="sm"
                >
                  <i class="fad fa-history" />
                  ประวัติการรับโบนัส
                </b-button>
              </div><br>
              <div>
                <b-button
                  v-b-modal.modal-wheel
                  variant="gradient-success"
                  block
                  size="sm"
                >
                  <i class="fad fa-history" />
                  ประวัติการหมุนกงล้อ
                </b-button>
              </div><br>
              <div>
                <b-button
                  v-b-modal.modal-invitelist
                  variant="gradient-warning"
                  block
                  size="sm"
                >
                  <i class="fad fa-history" />
                  รายชื่อเพื่อนที่แนะนำ
                </b-button>
              </div><br>
              <div>
                <b-button
                  variant="gradient-info"
                  block
                  size="sm"
                  @click="unlock_turn()"
                >
                  <i class="fad fa-history" />
                  ปลดล๊อคเทิร์น
                </b-button>
              </div>
              <div class="mt-2">
                <p>ฝากประจำสะสม : {{ userDetails.deposit_day_count ? userDetails.deposit_day_count: 0 }} วัน</p>
                <p>รับโปรฝากประจำล่าสุด : {{ userDetails.deposit_day_count_date ? userDetails.deposit_day_count_date: '-' }}</p>
              </div>
            </div>
            <div class="card-b d-flex justify-content-between">
              <small>-</small>
              <small>-</small>
            </div>
          </div>

          <!-- <div class="card-cradit-white white mb-1">
            <div class="p-1">
              <p style="text-align: center;">
                สกุลเงิน
              </p>

              <b-form-select
                v-model="currency"
                :options="currencyOPs"
                placeholder="เลือกสกุลเงิน"
                @input="changeUserEdit()"
              />
            </div>
          </div> -->
        </b-col>
      </b-row>

      <b-overlay
        :show="show"
        variant="transparent"
        opacity="0.99"
        blur="5px"
        rounded="sm"
      >
        <template #overlay>
          <div class="text-center">
            <b-icon-controller
              font-scale="3"
              animation="cylon"
            />
            <p id="cancel-label">
              กรุณารอสักครู่...
            </p>
          </div>
        </template>
        <div>
          <b-row class="match-height">
            <b-col md="6">
              <b-card no-body>
                <b-form-group class="p-1">
                  <h3 id="deposit">
                    ประวัติการฝาก
                  </h3>
                </b-form-group>
                <b-table
                  striped
                  hover
                  responsive
                  show-empty
                  class="position-relative items-center"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                  <template #cell(index)="data">
                    {{ perPage * (currentPage - 1) + (data.index + 1) }}
                  </template>
                  <template #empty="scope">
                    <div class="p-2 text-center">
                      <img
                        src="/box.png"
                        alt="empty"
                        height="40px"
                      > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
                    </div>
                  </template>
                  <template #cell(picture)="data">
                    <b-avatar
                      size="lg"
                      :src="data.item.picture"
                    />
                  </template>
                  <template #cell(ip)="data">
                    <div class="text-nowrap">
                      <a
                        :href="`http://${data.item.ip}`"
                        target="_blank"
                      >{{
                        data.item.ip
                      }}</a>
                    </div>
                  </template>
                  <!-- Column: Actions -->
                  <template #cell(actions)="data">
                    <div class="text-nowrap">
                      <feather-icon
                        :id="`invoice-row-${data.item.id}-preview-icon`"
                        icon="FileTextIcon"
                        size="16"
                        class="mx-1"
                        @click="
                          $router.push({
                            name: 'dashboard',
                            params: { id: data.item.id },
                          })
                        "
                      />
                      <b-tooltip
                        title="History Deposit & Withdraw"
                        :target="`invoice-row-${data.item.id}-preview-icon`"
                      />
                    </div>
                  </template>
                </b-table>

                <b-card-body
                  class="d-flex justify-content-between flex-wrap pt-0"
                >
                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="8"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPage"
                      size="sm"
                      inline
                      :options="pageOptions"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
                <b-modal
                  id="modal-1"
                  title="Add Class"
                  ok-only
                  ok-title="Save"
                >
                  <b-form-group
                    label="Class"
                    label-for="vi-first-name"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="CheckSquareIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        placeholder=""
                      />
                    </b-input-group>
                  </b-form-group>
                </b-modal>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-form-group class="mr-1 mb-md-0 p-2">
                  <h3 id="withdraw">
                    รายการถอน
                  </h3>
                </b-form-group>
                <b-table
                  striped
                  hover
                  responsive
                  show-empty
                  class="position-relative items-center"
                  :per-page="perPageWith"
                  :current-page="currentPageWith"
                  :items="items2"
                  :fields="fields2"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                  <template #cell(index)="data">
                    {{ perPageWith * (currentPageWith - 1) + (data.index + 1) }}
                  </template>
                  <template #empty="scope">
                    <div class="p-2 text-center">
                      <img
                        src="/box.png"
                        alt="empty"
                        height="40px"
                      > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
                    </div>
                  </template>
                  <template #cell(picture)="data">
                    <b-avatar
                      size="lg"
                      :src="data.item.picture"
                    />
                  </template>
                  <template #cell(ip)="data">
                    <div class="text-nowrap">
                      <a
                        :href="`http://${data.item.ip}`"
                        target="_blank"
                      >{{
                        data.item.ip
                      }}</a>
                    </div>
                  </template>
                  <!-- Column: Actions -->
                  <template #cell(actions)="data">
                    <div class="text-nowrap">
                      <feather-icon
                        :id="`invoice-row-${data.item.id}-preview-icon`"
                        icon="FileTextIcon"
                        size="16"
                        class="mx-1"
                        @click="
                          $router.push({
                            name: 'dashboard',
                            params: { id: data.item.id },
                          })
                        "
                      />
                      <b-tooltip
                        title="History Deposit &amp; Withdraw"
                        :target="`invoice-row-${data.item.id}-preview-icon`"
                      />
                    <!-- <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EditIcon"
            size="16"
            class="mx-1"
            @click="editData(data.item)"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          /> -->
                    </div>
                  </template>
                </b-table>

                <b-card-body
                  class="d-flex justify-content-between flex-wrap pt-0"
                >
                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="8"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPageWith"
                      size="sm"
                      inline
                      :options="pageOptions"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPageWith"
                      :total-rows="totalRowsWith"
                      :per-page="perPageWith"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
                <b-modal
                  id="modal-1"
                  title="Add Class"
                  ok-only
                  ok-title="Save"
                >
                  <b-form-group
                    label="Class"
                    label-for="vi-first-name"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="CheckSquareIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        placeholder=""
                      />
                    </b-input-group>
                  </b-form-group>
                </b-modal>
              </b-card>
            </b-col>
            <!-- -------------------------------------------------------------- -->
            <b-col cols="12">
              <b-card no-body>
                <b-card-body>
                  <div>
                    <b-row>
                      <b-col
                        cols="12"
                        md="4"
                        class="
                        d-flex
                        align-items-center
                        justify-content-start
                        mb-1 mb-md-0
                      "
                      >
                        <b-form-group class="mr-1 mb-md-0">
                          <h3 id="play">
                            รายการเล่นวันนี้
                          </h3>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="2"
                      >
                        <b-form-group
                          label="TXN ID"
                          label-for="txnIdFilter"
                        >
                          <b-form-input
                            v-model="txnIdFilter"
                            placeholder="ค้นหา TXN ID"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="2"
                      >
                        <b-form-group
                          label="Round ID"
                          label-for="roundIdFilter"
                        >
                          <b-form-input
                            v-model="roundIdFilter"
                            placeholder="ค้นหา Round ID"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group
                          label="ช่วงเวลา"
                          label-for="customDelimiter"
                        >
                          <flat-pickr
                            v-model="rangeDate"
                            class="form-control"
                            placeholder="เลือกช่วงเวลา"
                            :config="{
                              mode: 'range',
                              enableTime: true,
                              dateFormat: 'Y-m-d H:i',
                              time_24hr: true,
                              defaultHour: 0,
                            }"
                            @change="getHistory"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        md="1"
                        class="p-0"
                        style="margin-top: 20px"
                      >
                        <b-form-group>
                          <b-button
                            block
                            variant="gradient-primary"
                            @click="gethistory()"
                          >
                            ค้นหา
                          </b-button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
                <b-table
                  striped
                  hover
                  responsive
                  show-empty
                  class="position-relative items-center"
                  :per-page="perPageHis"
                  :items="itemsGame"
                  :fields="dynamicFieldsGame"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                  <template #cell(index)="data">
                    {{ perPageHis * (currentPageHis - 1) + (data.index + 1) }}
                  </template>
                  <template #empty="scope">
                    <div class="p-2 text-center">
                      <img
                        src="/box.png"
                        alt="empty"
                        height="40px"
                      > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
                    </div>
                  </template>
                  <template #cell(picture)="data">
                    <b-avatar
                      size="lg"
                      :src="data.item.picture"
                    />
                  </template>
                  <template #cell(ip)="data">
                    <div class="text-nowrap">
                      <a
                        :href="`http://${data.item.ip}`"
                        target="_blank"
                      >{{
                        data.item.ip
                      }}</a>
                    </div>
                  </template>
                  <template #cell(txnId)="data">
                    <div class="text-nowrap d-flex align-items-center">
                      <span
                        :id="`txn-${data.index}`"
                        class="text-truncate mr-1"
                      >
                        {{ data.item.txnId || '-' }}
                      </span>
                      <feather-icon
                        v-if="data.item.txnId"
                        icon="CopyIcon"
                        size="14"
                        class="cursor-pointer text-primary"
                        @click="copyToClipboard(data.item.txnId)"
                      />
                      <b-tooltip
                        v-if="data.item.txnId"
                        :target="`txn-${data.index}`"
                        :title="data.item.txnId"
                        placement="top"
                      />
                    </div>
                  </template>
                  <template #cell(roundId)="data">
                    <div class="text-nowrap d-flex align-items-center">
                      <span
                        :id="`round-${data.index}`"
                        class="text-truncate mr-1"
                      >
                        {{ data.item.roundId || '-' }}
                      </span>
                      <feather-icon
                        v-if="data.item.roundId"
                        icon="CopyIcon"
                        size="14"
                        class="cursor-pointer text-primary"
                        @click="copyToClipboard(data.item.roundId)"
                      />
                      <b-tooltip
                        v-if="data.item.roundId"
                        :target="`round-${data.index}`"
                        :title="data.item.roundId"
                        placement="top"
                      />
                    </div>
                  </template>

                  <template #cell(created_at)="data">
                    <div class="text-nowrap">
                      {{ formatDate(data.item.created_at) }}
                    </div>
                  </template>
                  <!-- Column: Actions -->
                  <template #cell(actions)="data">
                    <div
                      v-if="data.item.productId === 'PG'"
                      class="text-nowrap"
                    >

                      <button
                        class="btn-show"
                        @click="showAction(data.item), printConsoleToHtml"
                      >
                        รายละเอียด
                      </button>

                      <b-modal
                        ref="my-action"
                        hide-footer
                        title="รายงานการเล่น"
                      >
                        <!-- <div> -->
                        <iframe
                          frameborder="0"
                          width="100%"
                          height="600px"
                          :src="gameResultUrl"
                          size="lg"
                          title="รายละเอียด"
                        />
                      <!-- </div> -->
                      </b-modal>
                    <!-- <feather-icon
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="FileTextIcon"
                      size="16"
                      class="mx-1"
                      @click="
                        $router.push({
                          name: 'dashboard',
                          params: { id: data.item.id },
                        })
                      "
                    />
                    <b-tooltip
                      title="History Deposit & Withdraw"
                      :target="`invoice-row-${data.item.id}-preview-icon`"
                    /> -->
                    <!-- <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EditIcon"
            size="16"
            class="mx-1"
            @click="editData(data.item)"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          /> -->
                    </div>
                  </template>
                </b-table>

                <b-card-body
                  class="d-flex justify-content-between flex-wrap pt-0"
                >
                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="8"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPageHis"
                      size="sm"
                      inline
                      :options="pageOptions"
                      @change="gethistory()"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPageHis"
                      :total-rows="totalRowsGame"
                      :per-page="perPageHis"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                      @input="gethistory()"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
                <b-modal
                  id="modal-1"
                  title="Add Class"
                  ok-only
                  ok-title="Save"
                >
                  <b-form-group
                    label="Class"
                    label-for="vi-first-name"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="CheckSquareIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        placeholder=""
                      />
                    </b-input-group>
                  </b-form-group>
                </b-modal>
              </b-card>
            </b-col>
            <!-- *************************** -->
            <b-col cols="12">
              <b-card no-body>
                <b-card-body>
                  <div>
                    <b-row>
                      <b-col
                        cols="12"
                        md="4"
                        class="
                        d-flex
                        align-items-center
                        justify-content-start
                        mb-1 mb-md-0
                      "
                      >
                        <b-form-group class="mr-1 mb-md-0">
                          <h3 id="play">
                            รายการเล่นย้อนหลังเมื่อวาน (PG)
                          </h3>
                        </b-form-group>
                      </b-col>
                      <b-col md="3" />
                      <b-col
                        cols="12"
                        md="4"
                      >
                      <!-- <b-form-group
                        label="ช่วงเวลา"
                        label-for="customDelimiter"
                      >
                        <flat-pickr
                          v-model="rangeDatePG"
                          class="form-control"
                          :config="{
                            mode: 'range',
                            enableTime: true,
                            dateFormat: 'Y-m-d H:i',
                            time_24hr: true,
                            defaultHour: 0,
                          }"
                          @change="getHistory"
                        />
                      </b-form-group> -->
                      </b-col>
                      <b-col
                        md="1"
                        class="p-0"
                        style="margin-top: 20px"
                      >
                        <b-form-group>
                          <b-button
                            block
                            variant="gradient-primary"
                            @click="gethistoryPG()"
                          >
                            ค้นหา
                          </b-button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
                <b-table
                  striped
                  hover
                  responsive
                  show-empty
                  class="position-relative items-center"
                  :per-page="perPageHisPG"
                  :items="itemsGamePG"
                  :fields="fieldsGame"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                  <template #cell(index)="data">
                    {{ perPageHisPG * (currentPageHisPG - 1) + (data.index + 1) }}
                  </template>
                  <template #empty="scope">
                    <div class="p-2 text-center">
                      <img
                        src="/box.png"
                        alt="empty"
                        height="40px"
                      > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
                    </div>
                  </template>
                  <template #cell(picture)="data">
                    <b-avatar
                      size="lg"
                      :src="data.item.picture"
                    />
                  </template>
                  <template #cell(ip)="data">
                    <div class="text-nowrap">
                      <a
                        :href="`http://${data.item.ip}`"
                        target="_blank"
                      >{{
                        data.item.ip
                      }}</a>
                    </div>
                  </template>

                  <template #cell(actions)="data">
                    <div
                      v-if="data.item.productId === 'PG'"
                      class="text-nowrap"
                    >

                      <button
                        class="btn-show"
                        @click="showAction(data.item), printConsoleToHtml"
                      >
                        รายละเอียด
                      </button>

                      <b-modal
                        ref="my-action"
                        hide-footer
                        title="รายงานการเล่น"
                      >

                        <iframe
                          frameborder="0"
                          width="100%"
                          height="600px"
                          :src="gameResultUrl"
                          size="lg"
                          title="รายละเอียด"
                        />
                      </b-modal>
                    </div>
                  </template>
                </b-table>

                <b-card-body
                  class="d-flex justify-content-between flex-wrap pt-0"
                >

                  <b-form-group
                    label="Per Page"
                    label-cols="8"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPageHis"
                      size="sm"
                      inline
                      :options="pageOptions"
                      @change="gethistoryPG()"
                    />
                  </b-form-group>

                  <div>
                    <b-pagination
                      v-model="currentPageHisPG"
                      :total-rows="totalRowsGamePG"
                      :per-page="perPageHisPG"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                      @input="gethistoryPG()"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
                <b-modal
                  id="modal-1"
                  title="Add Class"
                  ok-only
                  ok-title="Save"
                >
                  <b-form-group
                    label="Class"
                    label-for="vi-first-name"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="CheckSquareIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        placeholder=""
                      />
                    </b-input-group>
                  </b-form-group>
                </b-modal>
              </b-card>
            </b-col>
            <!-- -------------------------------------------------------------- -->
            <b-col cols="12">
              <b-card no-body>
                <b-card-body>
                  <div>
                    <b-row>
                      <b-col
                        cols="12"
                        md="4"
                        class="
                        d-flex
                        align-items-center
                        justify-content-start
                        mb-1 mb-md-0
                      "
                      >
                        <b-form-group class="mr-1 mb-md-0">
                          <h3 id="play">
                            รายการเล่น SBOBET
                          </h3>
                        </b-form-group>
                      </b-col>
                      <b-col
                        md="3"
                      >
                        <b-form-group>
                          <label>Bet ID</label>
                          <b-form-input
                            id="floating-label2"
                            v-model="SboBetID"
                            type="text"
                            placeholder=""
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group
                          label="ช่วงเวลา"
                          label-for="customDelimiter"
                        >
                          <flat-pickr
                            v-model="rangeDateSbo"
                            class="form-control"
                            :config="{
                              mode: 'range',
                              enableTime: true,
                              dateFormat: 'Y-m-d H:i',
                              time_24hr: true,
                              defaultHour: 0,
                            }"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        md="1"
                        class="p-0"
                        style="margin-top: 20px"
                      >
                        <b-form-group>
                          <b-button
                            block
                            variant="gradient-primary"
                            @click="gethistorySbo()"
                          >
                            ค้นหา
                          </b-button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
                <b-table
                  striped
                  hover
                  responsive
                  show-empty
                  class="position-relative items-center"
                  :per-page="perPageHisSbo"
                  :items="itemsGameSbo"
                  :fields="fieldsGameSbo"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                  <template #cell(index)="data">
                    {{ perPageHisSbo * (currentPageHisSbo - 1) + (data.index + 1) }}
                  </template>
                  <template #empty="scope">
                    <div class="p-2 text-center">
                      <img
                        src="/box.png"
                        alt="empty"
                        height="40px"
                      > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
                    </div>
                  </template>
                  <template #cell(picture)="data">
                    <b-avatar
                      size="lg"
                      :src="data.item.picture"
                    />
                  </template>
                  <template #cell(ip)="data">
                    <div class="text-nowrap">
                      <a
                        :href="`http://${data.item.ip}`"
                        target="_blank"
                      >{{
                        data.item.ip
                      }}</a>
                    </div>
                  </template>
                  <!-- Column: Actions -->
                  <template #cell(actions)="data">
                    <div class="text-nowrap">
                      <feather-icon
                        :id="`invoice-row-${data.item.id}-preview-icon`"
                        icon="FileTextIcon"
                        size="16"
                        class="mx-1"
                        @click="
                          $router.push({
                            name: 'dashboard',
                            params: { id: data.item.id },
                          })
                        "
                      />
                      <b-tooltip
                        title="History Deposit & Withdraw"
                        :target="`invoice-row-${data.item.id}-preview-icon`"
                      />
                    <!-- <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EditIcon"
            size="16"
            class="mx-1"
            @click="editData(data.item)"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          /> -->
                    </div>
                  </template>
                </b-table>

                <b-card-body
                  class="d-flex justify-content-between flex-wrap pt-0"
                >
                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="8"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPageHisSbo"
                      size="sm"
                      inline
                      :options="pageOptions"
                      @change="gethistory()"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPageHisSbo"
                      :total-rows="totalRowsGameSbo"
                      :per-page="perPageHisSbo"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                      @input="gethistorySbo()"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
                <b-modal
                  id="modal-1"
                  title="Add Class"
                  ok-only
                  ok-title="Save"
                >
                  <b-form-group
                    label="Class"
                    label-for="vi-first-name"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="CheckSquareIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        placeholder=""
                      />
                    </b-input-group>
                  </b-form-group>
                </b-modal>
              </b-card>
            </b-col>
          </b-row>
          <!-- ประวัติรับโปร -->
          <b-modal
            id="modal-success"
            hide-footer
            modal-class="modal-dark"
            size="lg"
            centered
            title="ประวัติการรับโปรโมชั่น"
          >
            <b-card-text class="p-0">
              <b-table
                small
                striped
                hover
                responsive
                class="position-relative items-center"
                :per-page="perPagePro"
                :current-page="currentPagePro"
                :items="itemspro"
                :fields="fieldspro"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(index)="data">
                  {{ perPagePro * (currentPagePro - 1) + (data.index + 1) }}
                </template>
                <template #cell(picture)="data">
                  <b-avatar
                    size="lg"
                    :src="data.item.picture"
                  />
                </template>

                <template #cell(promotion)="data">
                  <span v-if="!data.item.promotion"> เทิร์นเติมเงินไม่รับโปร </span>
                  <span v-else> {{ data.item.promotion }}</span>
                </template>
                <template #cell(status)="data">
                  <span v-if="data.item.status === 1">ยังไม่ปลดล๊อคเทิร์น</span>
                  <span v-if="data.item.status === 2">ยังไม่ปลดล๊อคเทิร์น</span>
                  <span v-if="data.item.status === 3">ปลดล๊อคเทิร์นแล้ว</span>
                </template>
                <!-- Column: Actions -->
                <template #cell(actions)="data">
                  <div class="text-nowrap">
                    <feather-icon
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="FileTextIcon"
                      size="16"
                      class="mx-1"
                      @click="
                        $router.push({
                          name: 'dashboard',
                          params: { id: data.item.id },
                        })
                      "
                    />
                    <b-tooltip
                      title="History Deposit &amp; Withdraw"
                      :target="`invoice-row-${data.item.id}-preview-icon`"
                    />
                  </div>
                </template>
              </b-table>

              <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="8"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPagePro"
                    size="sm"
                    inline
                    :options="pageOptions"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPagePro"
                    :total-rows="totalRowsPro"
                    :per-page="perPagePro"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-card-text>
          </b-modal>
          <!-- ประวัติรับคืนยอดเสีย & ค่าคอม -->
          <b-modal
            id="modal-rolling"
            hide-footer
            modal-class="modal-dark"
            size="lg"
            centered
            title="ประวัติการรับโบนัส"
          >
            <b-card-text class="p-0">
              <b-table
                small
                striped
                hover
                responsive
                class="position-relative items-center"
                :per-page="perPage_bonus"
                :current-page="currentPage_bonus"
                :items="items_bonus"
                :fields="fields_bonus"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(index)="data">
                  {{ perPage_bonus * (currentPage_bonus - 1) + (data.index + 1) }}
                </template>
                <template #cell(picture)="data">
                  <b-avatar
                    size="lg"
                    :src="data.item.picture"
                  />
                </template>

                <template #cell(promotion)="data">
                  <span v-if="!data.item.promotion"> เทิร์นเติมเงินไม่รับโปร </span>
                  <span v-else> {{ data.item.promotion }}</span>
                </template>
                <template #cell(status)="data">
                  <span v-if="data.item.status === 1">ยังไม่ปลดล๊อคเทิร์น</span>
                  <span v-if="data.item.status === 2">ยังไม่ปลดล๊อคเทิร์น</span>
                  <span v-if="data.item.status === 3">ปลดล๊อคเทิร์นแล้ว</span>
                </template>
                <!-- Column: Actions -->
                <template #cell(actions)="data">
                  <div class="text-nowrap">
                    <feather-icon
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="FileTextIcon"
                      size="16"
                      class="mx-1"
                      @click="
                        $router.push({
                          name: 'dashboard',
                          params: { id: data.item.id },
                        })
                      "
                    />
                    <b-tooltip
                      title="History Deposit &amp; Withdraw"
                      :target="`invoice-row-${data.item.id}-preview-icon`"
                    />
                  </div>
                </template>
              </b-table>

              <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="8"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage_bonus"
                    size="sm"
                    inline
                    :options="pageOptions"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage_bonus"
                    :total-rows="totalRows_bonus"
                    :per-page="perPage_bonus"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-card-text>
          </b-modal>
          <!-- รายชื่อเพื่อนที่แนะนำ -->
          <b-modal
            id="modal-invitelist"
            hide-footer
            modal-class="modal-dark"
            size="lg"
            centered
            title="รายชื่อเพื่อนที่แนะนำ"
          >
            <b-card-text class="p-0">
              <b-table
                small
                striped
                hover
                responsive
                class="position-relative items-center"
                :per-page="perPage_invite"
                :current-page="currentPage_invite"
                :items="items_invite"
                :fields="fields_invite"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(index)="data">
                  {{ perPage_invite * (currentPage_invite - 1) + (data.index + 1) }}
                </template>

                <template #cell(fullname)="data">
                  <span> {{ data.item.name }} {{ data.item.surname }} </span>
                </template>

              </b-table>

              <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="8"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage_invite"
                    size="sm"
                    inline
                    :options="pageOptions"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage_invite"
                    :total-rows="totalRows_invite"
                    :per-page="perPage_invite"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-card-text>
          </b-modal>
          <!-- ประวัติการหมุนกงล้อ -->
          <b-modal
            id="modal-wheel"
            hide-footer
            modal-class="modal-dark"
            size="lg"
            centered
            title="ประวัติการหมุนกงล้อ"
          >
            <b-card-text class="p-0">
              <b-table
                small
                striped
                hover
                responsive
                class="position-relative items-center"
                :per-page="perPage_wheel"
                :current-page="currentPage_wheel"
                :items="items_wheel"
                :fields="fields_wheel"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(index)="data">
                  {{ perPage_wheel * (currentPage_wheel - 1) + (data.index + 1) }}
                </template>
                <template #cell(picture)="data">
                  <b-avatar
                    size="lg"
                    :src="data.item.picture"
                  />
                </template>

                <template #cell(promotion)="data">
                  <span v-if="!data.item.promotion"> เทิร์นเติมเงินไม่รับโปร </span>
                  <span v-else> {{ data.item.promotion }}</span>
                </template>
                <template #cell(status)="data">
                  <span v-if="data.item.status === 1">ยังไม่ปลดล๊อคเทิร์น</span>
                  <span v-if="data.item.status === 2">ยังไม่ปลดล๊อคเทิร์น</span>
                  <span v-if="data.item.status === 3">ปลดล๊อคเทิร์นแล้ว</span>
                </template>
                <!-- Column: Actions -->
                <template #cell(actions)="data">
                  <div class="text-nowrap">
                    <feather-icon
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="FileTextIcon"
                      size="16"
                      class="mx-1"
                      @click="
                        $router.push({
                          name: 'dashboard',
                          params: { id: data.item.id },
                        })
                      "
                    />
                    <b-tooltip
                      title="History Deposit &amp; Withdraw"
                      :target="`invoice-row-${data.item.id}-preview-icon`"
                    />
                  </div>
                </template>
              </b-table>

              <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="8"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage_wheel"
                    size="sm"
                    inline
                    :options="pageOptions"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage_wheel"
                    :total-rows="totalRows_wheel"
                    :per-page="perPage_wheel"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-card-text>
          </b-modal>
          <!-- เติมเครดิต -->
          <b-modal
            id="modal-deposit"
            title="เติมเครดิต"
            ok-title="เติมเครดิต"
            @ok="submitDeposit"
          >
            <b-overlay
              :show="show"
              variant="transparent"
              opacity="0.99"
              blur="5px"
              rounded="sm"
            >
              <template #overlay>
                <div class="text-center">
                  <b-icon-controller
                    font-scale="3"
                    animation="cylon"
                  />
                  <p id="cancel-label">
                    กรุณารอสักครู่...
                  </p>
                </div>
              </template>
              <validation-observer ref="simpleRules">
                <div class="row">
                  <div
                    v-if="currency === 'THB'"
                    class="col-8"
                  >
                    <b-form-group
                      label="จำนวนเงิน"
                      label-for="vi-first-name"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <i class="fad fa-donate" />
                        </b-input-group-prepend>
                        <b-form-input
                          id="vi-first-name"
                          v-model="amount"
                          name="amount"
                          type="number"
                          placeholder=""
                        />
                      </b-input-group>
                      <small class="text-danger">{{ amount < 1 || amount > MaxAmount ? `กรุณากรอกจำนวนเงิน 1-${MaxAmount}` : '' }}</small>
                    </b-form-group>

                  </div>
                  <div
                    v-else
                    class="col-8"
                  >
                    <b-form-group
                      label="จำนวนเงิน"
                      label-for="vi-first-name"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <i class="fad fa-donate" />
                        </b-input-group-prepend>
                        <b-form-input
                          id="vi-first-name"
                          v-model="amount"
                          name="amount"
                          type="number"
                          placeholder=""
                        />
                      </b-input-group>
                      <small class="text-danger">{{ amount < 1 || amount > MaxAmountKr ? `กรุณากรอกจำนวนเงิน 1-${MaxAmountKr}` : '' }}</small>
                    </b-form-group>

                  </div>
                  <!-- <div class="col-4">
                    <b-form-group
                      label="สกุลเงิน"
                      label-for="from"
                    >
                      <b-form-select
                        id="from"
                        v-model="currency"
                        :options="currencyOPs"
                        @input="changeUserEdit()"
                      />
                    </b-form-group>

                  </div> -->
                </div>
                <div class="row">
                  <div class="col">
                    <b-form-group
                      label="วันที่ (สลิป)"
                      label-for="dateslip"
                    >
                      <flat-pickr
                        id="dateslip"
                        v-model="dateslip"
                        class="form-control"
                      />
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group
                      label="เวลา (สลิป)"
                      label-for="time"
                    >
                      <div class="d-flex align-items-center">
                        <b-form-select
                          id="time"
                          v-model="time"
                          :options="timeOp1"
                          style="width: 80px"
                        />
                        <span style="margin-left: 5px; margin-right: 5px">:</span>
                        <b-form-select
                          id="time2"
                          v-model="time2"
                          :options="timeOp2"
                          style="width: 80px"
                        />
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group
                      label="เลือกบัญชีที่ฝากเข้า"
                      label-for="from"
                    >
                      <b-form-select
                        v-model="bankdep"
                        :options="bankdepOP"
                        text-field="username"
                        value-field="acc_number"
                      />
                    </b-form-group>
                  </div>
                </div>

              </validation-observer>
            </b-overlay>
          </b-modal>
          <!-- ตัดเครดิต -->
          <b-modal
            id="modal-holdcredit"
            title="ตัดเครดิตทั้งหมด"
            ok-title="ตัดเครดิต"
            @ok="submitHold"
          >
            <b-overlay
              :show="show"
              variant="transparent"
              opacity="0.99"
              blur="5px"
              rounded="sm"
            >
              <template #overlay>
                <div class="text-center">
                  <b-icon-controller
                    font-scale="3"
                    animation="cylon"
                  />
                  <p id="cancel-label">
                    กรุณารอสักครู่...
                  </p>
                </div>
              </template>
              <!-- <b-form-group>
                <div class="row">
                  <div class="col-12">
                    <div>
                      <label for="from">สกุลเงิน</label>
                      <div>
                        <b-form-select
                          v-model="currency"
                          :options="currencyOPs"
                          @input="changeUserEdit()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <br>
              </b-form-group> -->
            </b-overlay>
          </b-modal>
          <!-- เติมด้วยสลิป -->
          <b-modal
            id="modal-4"
            title="เติมเครดิตด้วยสลิป"
            ok-title="ยืนยัน"
            @ok="submitAutoSlip"
          >
            <b-overlay
              :show="show"
              variant="transparent"
              opacity="0.99"
              blur="5px"
              rounded="sm"
            >
              <template #overlay>
                <div class="text-center">
                  <b-icon-controller
                    font-scale="3"
                    animation="cylon"
                  />
                  <p id="cancel-label">
                    กรุณารอสักครู่...
                  </p>
                </div>
              </template>
              <b-form-group>
                <div class="row">
                  <div class="col-12">
                    <label for="from">เลือกบัญชีที่ฝากเข้า</label>
                    <b-form-select
                      v-model="autoSlipAcc"
                      :options="autoSlipBank"
                      text-field="show_text"
                      value-field="acc_number"
                    />
                  </div>
                  <!-- <div class="col-9">
                    <label for="from" />
                    <b-form-input
                      id="vi-first-name"
                      v-model="tel"
                      name="tel"
                      type="number"
                      placeholder="กรอกเบอร์โทรศัพท์แล้วกดค้นหา"
                    />
                  </div> -->
                  <!-- <div class="col-3">
                    <label for="from" />
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      block
                      @click="getUsersSearch()"
                    >
                      <feather-icon icon="SearchIcon" />
                      ค้นหา
                    </b-button>
                  </div> -->
                </div>
                <div>
                  <!-- <span
                    v-if="!member && search === true"
                    style="color :red;"
                  >
                    ไม่พบข้อมูล
                  </span> -->
                  <!-- <span
                    v-if="member && search === true"
                    style="color :green;"
                  >
                    {{ member.name }} {{ member.surname }} : {{ member.username }}
                  </span> -->
                  <div v-if="autoSlipAcc">
                    <b-form-group
                      label="เลือกสลิป"
                      label-for="image_link"
                    >
                      <b-form-file
                        placeholder="เลือกไฟล์รูปภาพ..."
                        accept="image/*"
                        @change="onFileChange"
                      />
                    </b-form-group>
                    <span
                      v-if="!qrCodeStatus"
                      style="color :red;"
                    >
                      ไม่พบQrCode
                      <b-form-input
                        id="vi-first-qrCodeResult"
                        v-model="qrCodeResult"
                        placeholder="กรอกข้อมูลจาก Qrcode"
                      />
                    </span>
                  </div>
                </div>
                <br>
              </b-form-group>
            </b-overlay>
          </b-modal>
        </div>
      </b-overlay>
    </div>
  </b-overlay>
</template>

<script>
import {
  // asdas
  // BInputGroupAppend,
  BFormCheckbox,
  BRow,
  BCol,
  BInputGroupPrepend,
  BModal,
  BCard,
  BTable,
  BAvatar,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BButton,
  BCardBody,
  VBToggle,
  BOverlay,
  BIconController,
  BFormFile,
  BTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'
// import VueApexCharts from 'vue-apexcharts'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import jsQR from 'jsqr'

export default {
  components: {
    BFormFile,
    BFormCheckbox,
    BOverlay,
    BRow,
    BCol,
    BInputGroupPrepend,
    BModal,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    // BInputGroupAppend,
    BButton,
    BCardBody,
    // StatisticCardWithAreaChart,
    // VueApexCharts,
    BIconController,
    vSelect,
    flatPickr,
    BTooltip,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      txnId: null,
      roundId: null,
      qrCodeResult: null,
      qrCodeStatus: true,
      autoSlipBank: [],
      autoSlipAcc: null,
      tel: null,
      from: null,
      fromOP: [
        { value: 'scb', text: 'scb' },
        { value: 'kbank', text: 'kbank' },
        { value: 'truewallet', text: 'truewallet' },
        { value: 'krunsri', text: 'krunsri' },
        { value: 'hana', text: 'hana' },
      ],
      timeOp1: [
        { value: '00', text: '00' }, { value: '01', text: '01' },
        { value: '02', text: '02' }, { value: '03', text: '03' },
        { value: '04', text: '04' }, { value: '05', text: '05' },
        { value: '06', text: '06' }, { value: '07', text: '07' },
        { value: '08', text: '08' }, { value: '09', text: '09' },
        { value: '10', text: '10' }, { value: '11', text: '11' },
        { value: '12', text: '12' }, { value: '13', text: '13' },
        { value: '14', text: '14' }, { value: '15', text: '15' },
        { value: '16', text: '16' }, { value: '17', text: '17' },
        { value: '18', text: '18' }, { value: '19', text: '19' },
        { value: '20', text: '20' }, { value: '21', text: '21' },
        { value: '22', text: '22' }, { value: '23', text: '23' },

      ],
      timeOp2: [
        { value: '00', text: '00' }, { value: '01', text: '01' },
        { value: '02', text: '02' }, { value: '03', text: '03' },
        { value: '04', text: '04' }, { value: '05', text: '05' },
        { value: '06', text: '06' }, { value: '07', text: '07' },
        { value: '08', text: '08' }, { value: '09', text: '09' },
        { value: '10', text: '10' }, { value: '11', text: '11' },
        { value: '12', text: '12' }, { value: '13', text: '13' },
        { value: '14', text: '14' }, { value: '15', text: '15' },
        { value: '16', text: '16' }, { value: '17', text: '17' },
        { value: '18', text: '18' }, { value: '19', text: '19' },
        { value: '20', text: '20' }, { value: '21', text: '21' },
        { value: '22', text: '22' }, { value: '23', text: '23' },
        { value: '24', text: '24' }, { value: '25', text: '25' },
        { value: '26', text: '26' }, { value: '27', text: '27' },
        { value: '28', text: '28' }, { value: '29', text: '29' },
        { value: '30', text: '30' }, { value: '31', text: '31' },
        { value: '32', text: '32' }, { value: '33', text: '33' },
        { value: '34', text: '34' }, { value: '35', text: '35' },
        { value: '36', text: '36' }, { value: '37', text: '37' },
        { value: '38', text: '38' }, { value: '39', text: '39' },
        { value: '40', text: '40' }, { value: '41', text: '41' },
        { value: '42', text: '42' }, { value: '43', text: '43' },
        { value: '44', text: '44' }, { value: '45', text: '45' },
        { value: '46', text: '46' }, { value: '47', text: '47' },
        { value: '48', text: '48' }, { value: '49', text: '49' },
        { value: '50', text: '50' }, { value: '51', text: '51' },
        { value: '52', text: '52' }, { value: '53', text: '53' },
        { value: '54', text: '54' }, { value: '55', text: '55' },
        { value: '56', text: '56' }, { value: '57', text: '57' },
        { value: '58', text: '58' }, { value: '59', text: '59' },

      ],
      themelist: [
        { value: 1, text: 'theme 1' },
        { value: 2, text: 'theme 2' },
      ],
      Edittelz: null,
      UserData: JSON.parse(localStorage.getItem('userData')),
      show: false,
      rangeDate: null,
      rangeDatePG: null,
      rangeDateSbo: null,
      SboBetID: null,
      balance: 0.0,
      today: '',
      perPage: 10,
      pageOptions: [10, 50, 100, 200, 500],
      totalRows: 1,
      totalRows2: 1,
      totalRowsGame: 1,
      currentPage: 1,
      perPageHis: 50,
      currentPageHis: 1,
      perPageHisPG: 50,
      itemsGamePG: [],
      totalRowsGamePG: 1,
      currentPageHisPG: 1,
      withamount: null,
      depamount: null,
      total: null,
      totalpro: null,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      banklist: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'index', label: 'no.' },
        { key: 'bank', label: 'บัญชี' },
        { key: 'from', label: 'มาจาก' },
        // { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'amount', label: 'จำนวน', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'bonus', label: 'โบนัส', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'balance', label: 'ยอดเงินคงเหลือ', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'status', label: 'status' },
        { key: 'time', label: 'เวลาสลิป' },
        {
          key: 'created_at',
          label: 'เวลา',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
        // { key: 'actions', label: 'Actions' },
      ],
      itemsGame: [],
      /* eslint-disable global-require */
      items: [],
      fields2: [
        { key: 'index', label: 'no.' },
        // { key: 'username', label: 'ยูสเซอร์เนม' },
        {
          key: 'amount',
          label: 'จำนวน',
          formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        },
        { key: 'balance', label: 'ยอดเงินคงเหลือ', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'status', label: 'status' },
        { key: 'note', label: 'หมายเหตุ' },
        {
          key: 'created_at',
          label: 'เวลา',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
        // { key: 'actions', label: 'Actions' },
      ],
      fieldspro: [
        { key: 'index', label: 'no.' },
        { key: 'promotion', label: 'ชื่อโปรโมชั่น' },
        { key: 'turnover', label: 'เทิร์นที่ลูกค้าต้องทำ', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'userturnover', label: 'เทิร์นลูกค้า', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'maxamount', label: 'ถอนได้สูงสุด', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'status', label: 'status' },
        { key: 'update_by', label: 'ปลดเทิร์นโดย' },
        {
          key: 'created_at',
          label: 'เวลารับโปร',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
        // { key: 'actions', label: 'Actions' },
      ],
      seriesDep: [95],
      seriesWith: [75],
      seriesTotal: [65],
      chartOptionsDep: {
        chart: {
          height: 350,
          type: 'radialBar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '70%',
              background: 'tranparent',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35,
              },
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px',
              },
              value: {
                // formatter(val) {
                //   return parseInt(val)
                // },
                color: '#111',
                fontSize: '36px',
                show: true,
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['ยอดฝาก'],
      },
      chartOptionsWith: {
        chart: {
          height: 350,
          type: 'radialBar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '70%',
              background: 'tranparent',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35,
              },
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px',
              },
              value: {
                // formatter(val) {
                //   return parseInt(val)
                // },
                color: '#111',
                fontSize: '36px',
                show: true,
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['ยอดถอน'],
      },
      chartOptionsTotal: {
        chart: {
          height: 350,
          type: 'radialBar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '70%',
              background: 'tranparent',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35,
              },
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px',
              },
              value: {
                // formatter(val) {
                //   return parseInt(val)
                // },
                color: '#111',
                fontSize: '36px',
                show: true,
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['ยอดรวมทั้งหมด'],
      },
      // data: {}, ++
      /* eslint-disable global-require */
      fieldsGame: [
        { key: 'index', label: 'no.' },
        { key: 'productId', label: 'ค่ายเกมส์' },
        // { key: 'appid', label: 'appid' },
        { key: 'betType', label: 'betType' },
        { key: 'txnId', label: 'txnId' },
        { key: 'roundId', label: 'roundId' },
        { key: 'balanceBefore', label: 'ยอดเงินก่อนแทง', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'balance', label: 'ยอกเงินคงเหลือ', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'betAmount', label: 'ยอดแทง', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'winAmount', label: 'ยอดชนะ', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        {
          key: 'created_at',
          label: 'เวลา',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },

        // {
        //   key: 'created_at',
        //   label: 'created at',
        //   formatter: value => moment(value)
        //     .tz('Asia/Bangkok')
        //     .format('DD/MM/YYYY HH:mm:ss'),
        // },
        // { key: 'actions', label: 'Actions' },
      ],
      items2: [],
      itemspro: [],
      search_userID: null,
      userDetails: [],
      userslist: [],
      addNewDataSidebar: false,
      depositSeries: [
        {
          name: 'deposit',
          data: [],
        },
      ],
      withdrawSeries: [
        {
          name: 'withdraw',
          data: [],
        },
      ],
      turn: '',
      turnhis: '',
      options: [
        { value: 1, text: 'Active: เข้าเล่นได้ปกติ' },
        { value: 2, text: 'Locked: เข้าสู่ล็อบบี้ไม่ได้ เข้าเล่นไม่ได้' },
        // { value: 0, text: 'Suspended: เข้าสู่ล็อบบี้ได้ แต่เข้าเล่นไม่ได้' },
      ],
      datalist: {
        depamount: 0,
        withamount: 0,
        total: 0,
      },
      optionsMember: [],
      optionsMemShow: false,
      optionsCheck: false,
      currentPageHisSbo: 1,
      totalRowsGameSbo: 0,
      perPageHisSbo: 10,
      itemsGameSbo: [],
      fieldsGameSbo: [
        { key: 'index', label: 'no.' },
        { key: 'productId', label: 'ค่ายเกมส์' },
        { key: 'betid', label: 'BetID' },
        { key: 'betType', label: 'BetType' },
        { key: 'balanceBefore', label: 'ยอดเงินก่อนแทง', formatter: value => Number(value).toFixed(2) },
        { key: 'balance', label: 'ยอกเงินคงเหลือ', formatter: value => Number(value).toFixed(2) },
        { key: 'betAmount', label: 'ยอดแทง', formatter: value => Number(value).toFixed(2) },
        { key: 'winAmount', label: 'ยอดชนะ', formatter: value => Number(value).toFixed(2) },
        {
          key: 'created_at',
          label: 'เวลา',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
        { key: 'actions', label: 'Actions' },
      ],
      currentPageWith: 1,
      totalRowsWith: 0,
      perPageWith: 10,
      currentPagePro: 1,
      totalRowsPro: 0,
      perPagePro: 10,
      gameResultUrl: '',
      balance_kr: 0,
      banklist_kr: [],
      currency: 'THB',
      currencyOPs: ['THB'],
      currency_options: ['THB'],
      items_bonus: [],
      totalRows_bonus: 0,
      currentPage_bonus: 1,
      perPage_bonus: 10,
      fields_bonus: [
        { key: 'index', label: 'no.' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'label_type', label: 'ประเภท' },
        { key: 'amount', label: 'จำนวนเงิน', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        // { key: 'currency', label: 'สกุลเงิน' },
        {
          key: 'created_at',
          label: 'รับเมื่อ',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
        // { key: 'actions', label: 'Actions' },
      ],
      items_wheel: [],
      totalRows_wheel: 0,
      currentPage_wheel: 1,
      perPage_wheel: 10,
      fields_wheel: [
        { key: 'index', label: 'no.' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'bunus_text', label: 'รางวัล' },
        {
          key: 'created_at',
          label: 'รับเมื่อ',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
      ],
      chip: 0,
      UserRank: {
        level: 'Bronze',
      },
      search_user: null,
      MaxAmount: 0,
      MaxAmountKr: 0,
      amount: null,
      dateslip: moment().tz('Asia/Bangkok').format('YYYY-MM-DD'),
      time: null,
      time2: null,
      items_invite: [],
      totalRows_invite: 0,
      currentPage_invite: 1,
      perPage_invite: 10,
      fields_invite: [
        { key: 'index', label: 'no.' },
        { key: 'fullname', label: 'ชื่อ-นามสกุล' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'tel', label: 'เบอร์โทร' },
        {
          key: 'created_at',
          label: 'สมัครเมื่อ',
          formatter: value => moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
        },
      ],
      bankdepOP: [],
      bankdep: null,
    }
  },
  computed: {
    dynamicFieldsGame() {
      const baseFields = [
        { key: 'index', label: 'no.' },
        { key: 'productId', label: 'ค่ายเกมส์' },
        { key: 'betType', label: 'betType' },
        { key: 'txnId', label: 'txnId' },
        { key: 'roundId', label: 'roundId' },
        { key: 'balanceBefore', label: 'ยอดเงินก่อนแทง', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'balance', label: 'ยอกเงินคงเหลือ', formatter: value => Number(value).toLocaleString(undefined, {  minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'betAmount', label: 'ยอดแทง', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { key: 'winAmount', label: 'ยอดชนะ', formatter: value => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        {
          key: 'created_at',
          label: 'เวลา',
        },
      ]
      // เช็คว่ามีข้อมูล PG ในตารางหรือไม่
      const hasPG = this.itemsGame.some(item => item.productId === 'PG')
      if (hasPG) {
        baseFields.push({ key: 'actions', label: 'Actions' })
      }
      return baseFields
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    // this.$http.get('/analytics/data').then(response => {
    //   this.data = response.data
    // })
  },
  async mounted() {
    this.getPro()
    if (this.currency === 'THB') {
      this.getDepWit()
    } else {
      this.getDepWitKR()
    }
    this.Get_bank()
    this.Get_bank_kr()
    this.getbalance()
    this.Getuserdetail()
    this.GetHistoryBonus()
    this.GetHistoryWheel()
    this.getAgent()
    this.GetHistoryInvitelist()
    this.GetBankDep()
    this.getAutoSlipBank()
  },
  methods: {
    formatDate(value) {
      return moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'คัดลอกสำเร็จ',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      })
    },
    async submitAutoSlip() {
      if (!this.autoSlipAcc || !this.userDetails.username || this.qrCodeResult === '' || !this.qrCodeResult) {
        this.SwalError('ข้อมูลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง')
        return
      }
      this.show = true
      try {
        const obj = {
          code: this.qrCodeResult,
          account_number: this.autoSlipAcc,
          username: this.userDetails.username,
        }
        const { data: res } = await this.$http.post('/scb/adminvelifyslip', obj)
        // console.log(res)
        if (res.success) {
          this.Success(res.mes)
        } else {
          this.SwalError(res.mes)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.show = false
      }
    },
    onFileChange(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = e => {
        const image = new Image()
        image.src = e.target.result
        image.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(image, 0, 0)

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
          const qrCode = jsQR(imageData.data, canvas.width, canvas.height)

          if (qrCode) {
            this.qrCodeResult = qrCode.data
            this.qrCodeStatus = true
          } else {
            this.qrCodeResult = ''
            this.qrCodeStatus = false
          }
        }
      }

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    getAutoSlipBank() {
      this.$http
        .get('/autoslip/banklist')
        .then(response => {
          if (response.data.success) {
            this.autoSlipBank = response.data.bank
          }
        })
        .catch(error => console.log(error))
    },
    GetBankDep() {
      this.$http
        .get('/bank/list/new')
        .then(response => {
          this.bankdepOP = response.data
        })
        .catch(error => console.log(error))
    },
    Commas(x) {
      if (!x) {
        return 0
      } if (x % 1 !== 0) {
        return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    copyuserdata() {
      // ข้อความที่ต้องการคัดลอก
      const textToCopy = `
        ชื่อ - นามสกุล : ${this.userDetails.name} ${this.userDetails.surname}
        เบอร์โทร : ${this.userDetails.tel}
        เลขบัญชี : ${this.userDetails.currency === 'THB' ? this.userDetails.acc_no : this.userDetails.accno_kr}
        ธนาคาร : ${this.findBank()}
      `

      // ใช้ Clipboard API เพื่อคัดลอกข้อความ
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'คัดลองข้อมูลสำเร็จ',
              icon: 'SearchIcon',
              variant: 'success',
            },
          })
        })
        // eslint-disable-next-line no-unused-vars
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'คัดลอกข้อมูลไม่สำเร็จ',
              icon: 'SearchIcon',
              variant: 'warning',
            },
          })
        })
    },
    findBank() {
      if (this.userDetails.currency === 'THB') {
        const index = this.banklist.findIndex(bank => bank.bankcode === this.userDetails.bank)
        // ถ้าพบธนาคาร รีเทิร์นชื่อธนาคาร
        if (index !== -1) {
          return this.banklist[index].name
        }
        return 'ไม่พบธนาคาร'
      }
      const index = this.banklist_kr.findIndex(bank => bank.code === this.userDetails.bank_kr)
      // ถ้าพบธนาคาร รีเทิร์นชื่อธนาคาร
      if (index !== -1) {
        return this.banklist_kr[index].name
      }
      return 'ไม่พบธนาคาร'
    },
    // เติมเงิน
    submitDeposit() {
      if (this.time && this.time2 && this.bankdep) {
        this.show = true
        const formData = {
          username: this.$route.params.id,
          amount: this.amount,
          dateslip: this.dateslip,
          time: `${this.time}:${this.time2}`,
          bank: this.from,
          currency: this.currency,
          bankdep: this.bankdep,
        }
        this.$http
          .post('/deposit/store', formData)
          .then(() => {
            this.show = false
            this.changeUserEdit()
            this.getbalance()
            this.time = null
            this.time2 = null
            this.amount = ''
            this.from = null
            this.Success('เติมเครดิต สำเร็จ')
          })
          .catch(error => {
            this.show = false
            this.time = null
            this.time2 = null
            this.amount = ''
            this.from = null
            this.SwalError(error.response.data.message)
          })
      } else {
        this.show = false
        this.SwalError('กรุณาใส่ให้ครบทุกช่อง')
      }
    },
    // ตัดเครดิต
    submitHold() {
      this.show = true
      const formData = {
        username: this.$route.params.id,
        currency: this.currency,
      }
      this.$http
        .post('/withdraw/holdstore/all', formData)
        .then(() => {
          this.show = false
          this.changeUserEdit()
          this.getbalance()
          this.amount = ''
          this.Success('ตัดเครดิตสำเร็จ')
        })
        .catch(error => {
          this.show = false
          this.SwalError(error.response.data.message)
        })
    },
    async searchuser() {
      this.show = true
      this.$http
        .get(`/searchuser?search_user=${this.search_user}`)
        .then(async response => {
          if (response.data.status === true) {
            const { username } = response.data.data // รับ username จาก response
            const currentUsername = this.$route.params.username // รับ username ปัจจุบันจาก params

            // เช็คว่าชื่อผู้ใช้ใหม่กับชื่อผู้ใช้ปัจจุบันเหมือนกันหรือไม่
            if (username !== currentUsername) {
              const newUrl = `/Deposit-Withdraw/${username}`
              await this.$router.push(newUrl)

              this.getPro()
              if (this.currency === 'THB') {
                this.getDepWit()
              } else {
                this.getDepWitKR()
              }
              this.Get_bank()
              this.Get_bank_kr()
              this.getbalance()
              this.Getuserdetail()
              this.GetHistoryBonus()
              this.GetHistoryWheel()
              this.GetHistoryInvitelist()
              // แสดงการแจ้งเตือนเมื่อพบยูสเซอร์
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'พบยูสเซอร์',
                  icon: 'SearchIcon',
                  variant: 'success',
                },
              })
            } else {
              // ถ้าชื่อผู้ใช้เหมือนกัน แสดงการแจ้งเตือน
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'ยูสเซอร์นี้คือยูสเซอร์ปัจจุบัน',
                  icon: 'SearchIcon',
                  variant: 'info',
                },
              })
            }
            this.show = false
          } else {
            // กรณีไม่พบยูสเซอร์
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'ไม่พบยูสเซอร์นี้',
                icon: 'SearchIcon',
                variant: 'warning',
              },
            })
            this.show = false // ซ่อน loader
          }
        })
        .catch(error => {
          console.log(error)
          this.show = false // ซ่อน loader
        })
    },
    async GetHistoryBonus() {
      await this.$http
        .get(
          `/history/bonus/${this.$route.params.id}`,
        )
        .then(response => {
          this.UserRank = response.data.Rank
          this.items_bonus = response.data.BonusHistory
          this.totalRows_bonus = response.data.BonusHistory.length
        })
        .catch(error => console.log(error))
    },
    async GetHistoryWheel() {
      await this.$http
        .get(
          `/history/wheel/${this.$route.params.id}`,
        )
        .then(response => {
          this.items_wheel = response.data
          this.totalRows_wheel = response.data.length
        })
        .catch(error => console.log(error))
    },
    async GetHistoryInvitelist() {
      await this.$http
        .get(
          `/invite/list/${this.$route.params.id}`,
        )
        .then(response => {
          this.items_invite = response.data
          this.totalRows_invite = response.data.length
        })
        .catch(error => console.log(error))
    },
    getAgent() {
      this.$http
        .get('/agent/show')
        .then(response => {
          const AgData = response.data
          if (AgData.max_manual_dep_level1 && AgData.max_manual_dep_level2) {
            if (this.UserData.role === 'super admin') {
              this.MaxAmount = AgData.max_manual_dep_level2
              this.MaxAmountKr = AgData.max_manual_depkr_level2
            } else {
              this.MaxAmount = AgData.max_manual_dep_level1
              this.MaxAmountKr = AgData.max_manual_depkr_level1
            }
          }
        })
        .catch(error => console.log(error))
    },
    async  CheckName(accno) {
      const obj = {
        acc_no: accno,
        bank: this.userDetails.bank,
      }

      await this.$http
        .post('/scb/CheckNameBankV2', obj)
        .then(response => {
          if (response.data.status === false) {
            this.$swal({
              icon: 'warning',
              title: '<h3 style="color: #141414">แจ้งเตือน</h3>',
              text: response.data.msg,
              customClass: {
                confirmButton: 'btn btn-warning',
              },
            })
          } else {
            this.$swal({
              icon: 'success',
              title: '<h3 style="color: #141414">Success</h3>',
              text: response.data.AccName,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
        .catch(error => console.log(error))
    },
    showAction(item) {
      this.show = true
      const obj = {
        username: item.username,
        productId: item.productId,
        platformTxId: item.platformTxId,
        roundId: item.roundId,

      }
      this.$http
        .post('history/HistoryResultAWC', obj)
        .then(response => {
          // console.log(response.data)
          this.gameResultUrl = response.data.url
          this.show = false
        })
        .catch(error => {
          console.log(error)
          this.show = false
        })
      this.$refs['my-action'].show()
      // console.log(params)
    },
    unlock_turn() {
      this.$swal({
        title: 'แจ้งเตือน ?',
        text: 'ยืนยันที่จะปลดเทิร์นหรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.show = true
          const obj = {
            username: this.$route.params.id,
            currency: this.currency,
          }
          // console.log(Obj)
          this.$http
            .post('/promotion/unlockedturn', obj)
            .then(response => {
              this.getPro()
              if (response.data === 'success') {
                this.$swal({
                  icon: 'success',
                  title: 'สำเร็จ',
                  text: 'ปลดล็อคเทิร์นสำเร็จ',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                this.show = false
                this.$swal({
                  icon: 'warning',
                  title: 'Error',
                  text: 'ปลดล็อคเทิร์นไม่สำเร็จ',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              }
            })
            .catch(error => console.log(error))
        } else {
          this.show = false
          this.$swal('ยกเลิก', 'ยกเลิกการปลดเทิร์น!', 'error')
        }
      })
    },
    getUserslist(data, type) {
      this.optionsMemShow = true
      if (data) {
        const params = {
          search: data,
          type,
        }
        this.$http
          .post('/users/list/search', params)
          .then(response => {
            if (response.data.length > 0) {
              this.optionsCheck = true
              this.userDetails.invited_by = response.data[0].invite_code
              if (type === 'name') {
                this.$swal({
                  icon: 'success',
                  title: '<h3 style="color: #000">ค้นหาสำเร็จ</h3>',
                  text: `พบข้อมูลชื่อผู้แนะนำ ${response.data.length} ราย`,
                  customClass: {
                    confirmButton: 'btn btn-warning',
                  },
                })
              }
            } else {
              this.userDetails.invited_by = null
              this.optionsCheck = false
              this.$swal({
                icon: 'danger',
                title: '<h3 style="color: #000">แจ้งเตือน !</h3>',
                text: 'ไม่พบข้อมูลผู้แนะนำ',
                customClass: {
                  confirmButton: 'btn btn-warning',
                },
              })
            }
            this.optionsMemShow = false
            this.optionsMember = response.data
          })
          .catch(error => console.log(error))
      } else {
        this.optionsMemShow = false
        this.optionsMember = []
        this.optionsCheck = false
        this.$swal({
          icon: 'danger',
          title: '<h3 style="color: #000">แจ้งเตือน !</h3>',
          text: 'กรุณากรอกชื่อผู้แนะนำเพื่อค้นหา',
          customClass: {
            confirmButton: 'btn btn-warning',
          },
        })
      }
    },
    Edittel(data) {
      const params = {
        tel: data,
        username: this.$route.params.id,
      }
      this.$http
        .post('/member/UpdateTel',
          params)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          // console.log(response.data)
          this.$router.push({ name: 'member' })
          this.$swal({
            icon: 'success',
            title: '<h3 style="color: #000">สำเร็จ</h3>',
            text: 'แก้ไขเบอร์โทรสำเร็จ',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
        .catch(error => {
          this.$swal({
            icon: 'danger',
            title: '<h3 style="color: #000">แจ้งเตือน !</h3>',
            text: 'มีเบอร์โทรนี้อยู่ในระบบแล้ว',
            customClass: {
              confirmButton: 'btn btn-warning',
            },
          })
          console.log(error)
        })
    },
    getbalance() {
      this.show = true
      const params = {
        username: this.$route.params.id,
      }
      this.$http
        .get('/balance/getbalance', {
          params,
        })
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.balance = response.data.balance
          this.chip = response.data.chip
          this.balance_kr = response.data.balance_kr
        })
        .catch(error => console.log(error))
    },
    getHistory() {
      // console.log(this.rangeDate)
      const rangArray = this.rangeDate.split(' to ')
      // eslint-disable-next-line no-unused-vars
      const start = rangArray[0]
      // eslint-disable-next-line no-unused-vars
      const end = rangArray[1]
      // console.log(start)
      // console.log(end)
    },
    gethistory() {
      const rangArray = this.rangeDate.split(' to ')
      const start = rangArray[0]
      const end = rangArray[1]
      this.show = true
      const obj = {
        username: this.$route.params.id,
        start,
        end,
        page: this.currentPageHis,
        perPage: this.perPageHis,
        txnId: this.txnIdFilter,
        roundId: this.roundIdFilter,
      }
      this.$http
        .post('/history/play', obj)
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.listdata = response.data.data
          this.onFilteredHis(response.data)
        })
        .catch(error => console.log(error))
    },
    onFilteredHis(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems)
      this.itemsGame = filteredItems.data
      this.totalRowsGame = filteredItems.total
    },
    gethistoryPG() {
      // const rangArray = this.rangeDatePG.split(' to ')
      const start = moment().tz('Asia/Bangkok').subtract('days', 1).format('YYYY-MM-DD 00:00')
      const end = moment().tz('Asia/Bangkok').subtract('days', 1).format('YYYY-MM-DD 00:00')
      this.show = true
      const obj = {
        username: this.$route.params.id,
        start,
        end,
        page: this.currentPageHisPG,
        perPage: this.perPageHisPG,
      }
      this.$http
        .post('/history/play/pg', obj)
        .then(response => {
          // console.log(response.data)
          // this.listdata = response.data.data
          this.show = false
          this.onFilteredHisPG(response.data)
        })
        .catch(error => console.log(error))
    },
    onFilteredHisPG(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems)
      this.itemsGamePG = filteredItems.data
      this.totalRowsGamePG = filteredItems.total
    },
    gethistorySbo() {
      const rangArray = this.rangeDateSbo.split(' to ')
      const start = rangArray[0]
      const end = rangArray[1]
      this.show = true
      const obj = {
        username: this.$route.params.id,
        start,
        end,
        page: this.currentPageHisSbo,
        perPage: this.perPageHisSbo,
        SboBetID: this.SboBetID,
      }
      this.$http
        .post('/zean/history/play/sbo', obj)
        .then(response => {
          // console.log(response.data)
          // this.listdata = response.data.data
          this.show = false
          this.onFilteredHisSbo(response.data)
        })
        .catch(error => console.log(error))
    },
    onFilteredHisSbo(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems)
      this.itemsGameSbo = filteredItems.data
      this.totalRowsGameSbo = filteredItems.total
    },
    changeUserEdit() {
      if (this.currency === 'THB') {
        this.getDepWit()
        this.getPro()
      } else {
        this.getDepWitKR()
        this.getProKR()
      }
      this.Getuserdetail()
      // this.Get_bank()
      // this.Get_userlists()
      // this.gethistory()
      // this.search_userID = null
    },
    Get_bank() {
      this.$http
        .get('/bank/list')
        .then(response => {
          this.banklist = response.data
        })
        .catch(error => console.log(error))
    },
    Get_bank_kr() {
      this.$http
        .get('/bank/list/kr')
        .then(response => {
          this.banklist_kr = response.data
          // console.log(this.banklist_kr)
        })
        .catch(error => console.log(error))
    },
    Get_userlists() {
      this.$http
        .get('/users/list')
        .then(response => {
          this.userslist = response.data
        })
        .catch(error => console.log(error))
    },
    update_member() {
      if (this.userDetails.zean === true) {
        this.userDetails.zean = 1
      } else {
        this.userDetails.zean = 0
      }

      if (this.userDetails.blacklist === true) {
        this.userDetails.blacklist = 1
      } else {
        this.userDetails.blacklist = 0
      }
      if (this.userDetails.vip === true) {
        this.userDetails.vip = 1
      } else {
        this.userDetails.vip = 0
      }
      const params = {
        currency: this.userDetails.currency,
        name: this.userDetails.name,
        password: this.userDetails.passwords,
        surname: this.userDetails.surname,
        bank: this.userDetails.bank,
        acc_no: this.userDetails.acc_no,
        bank_kr: this.userDetails.bank_kr,
        accno_kr: this.userDetails.accno_kr,
        trueaccno: this.userDetails.trueaccno,
        status: this.userDetails.status,
        zean: this.userDetails.zean,
        zean_percent: this.userDetails.zean_percent,
        line_id: this.userDetails.line_id,
        invited_by: this.userDetails.invited_by,
        blacklist: this.userDetails.blacklist,
        blacklist_remark: this.userDetails.blacklist_remark,
        vip: this.userDetails.vip,
        p2p_uid: this.userDetails.p2p_uid,
      }

      // console.log(this.UserData.role)
      if (this.UserData.role === 'super admin') {
        params.tel = this.userDetails.tel
      }
      this.$http
        .post(
          `/users/update/${this.userDetails.id}`,
          params,
        )
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          // console.log(response)
          this.show = false
          this.Success('แก้ไขข้อมูลลูกค้าเรียบร้อย')
          this.Getuserdetail(response.data.username)
        })
        .catch(error => {
          this.SwalWarning(error.response.data.message)
        })
    },
    async Getuserdetail(username = null) {
      if (!username) {
        // eslint-disable-next-line no-param-reassign
        username = this.$route.params.id
      }
      this.$http
        .get(
          `/users/showByusername/${username}`,
        )
        .then(response => {
          this.userDetails = response.data
          if (this.userDetails.zean === 1) {
            this.userDetails.zean = true
          } else {
            this.userDetails.zean = false
          }
          if (this.userDetails.blacklist === 1) {
            this.userDetails.blacklist = true
          } else {
            this.userDetails.blacklist = false
          }
          if (this.userDetails.vip === 1) {
            this.userDetails.vip = true
          } else {
            this.userDetails.vip = false
          }
          if (this.userDetails.invited_by) {
            this.optionsCheck = true
            this.getUserslist(this.userDetails.invited_by, 'invited_by')
          }
        })
        .catch(error => console.log(error))
    },
    canclePro(turn) {
      this.$swal({
        title: '<h3 style="color: #000">Are you sure?</h3>',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancle it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.$http
            // eslint-disable-next-line no-underscore-dangle
            .get(
              // eslint-disable-next-line no-underscore-dangle
              `/history/canclepro/${turn._id}`,
            )
            .then(response => {
              this.getPro()
              if (response.data) {
                this.$swal({
                  icon: 'success',
                  title: '<h3 style="color: #000">Cancled!</h3>',
                  text: 'Your Promotion has been Cancled.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
            .catch(error => this.SwalError(error.response.data.message))
        } else {
          this.$swal(
            '<h3 style="color: #000">Cancelled</h3>',
            'not been cancled !',
            'error',
          )
        }
      })
    },
    async getPro() {
      await this.$http
        .get(
          `/history/getturnpro/${this.$route.params.id}`,
        )
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.turn = response.data.turnover
          this.turnhis = response.data.turnoverall
          this.onFilteredPro(response.data.turnoverall)
        })
        .catch(error => console.log(error))
    },
    async getProKR() {
      await this.$http
        .get(
          `/history/getturnproKR/${this.$route.params.id}`,
        )
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.turn = response.data.turnover
          this.turnhis = response.data.turnoverall
          this.onFilteredPro(response.data.turnoverall)
        })
        .catch(error => console.log(error))
    },
    onFilteredPro(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems)
      this.itemspro = filteredItems
      this.totalRowsPro = filteredItems.length
      this.totalpro = filteredItems.total
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    getDepWit() {
      this.$http
        .get(
          `/history/depwithlist/${this.$route.params.id}`,
        )
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.depositSeries[0].data = response.data.ddata
          this.withdrawSeries[0].data = response.data.wdata
          this.datalist = response.data
          this.onFiltered(response.data)
        })
        .catch(error => console.log(error))
    },
    getDepWitKR() {
      this.$http
        .get(
          `/history/depwithlistkr/${this.$route.params.id}`,
        )
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.depositSeries[0].data = response.data.ddata
          this.withdrawSeries[0].data = response.data.wdata
          this.datalist = response.data
          this.onFiltered(response.data)
        })
        .catch(error => console.log(error))
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems)
      this.items = filteredItems.DataDep
      this.items2 = filteredItems.DataWith
      this.totalRows = filteredItems.DataDep.length
      this.totalRowsWith = filteredItems.DataWith.length
      // this.userData = filteredItems.userData
      this.withamount = filteredItems.withamount
      this.depamount = filteredItems.depamount
      this.total = filteredItems.total
      this.seriesDep = [filteredItems.depamount]
      this.seriesWith = [filteredItems.withamount]
      this.seriesTotal = [filteredItems.total]
      // console.log(this.userData)
    },
    Get_userlist() {
      this.$http
        .get('/api/user/list')
        .then(response => {
          this.onFiltered(response.data.message)
        })
        .catch(error => console.log(error))
    },
    addData() {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.toggleDataSidebar(true)
      this.datasidebar = {}
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.toggleDataSidebar(true)
      this.datasidebar = data
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #000">Error!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
    SwalWarning(mes) {
      this.$swal({
        icon: 'warning',
        title: '<h3 style="color: #000">แจ้งเตือน !</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>
<style scoped>
iframe {
  border-width: 0 !important;
  overflow: clip !important;
  border-style: none !important;
    border-color: transparent !important;
    border-image: none !important;
}
.btn-show {
  background: #005d8873;
  color: #ffffff;
  border: none;
  border-radius: 15px;
  padding: 3px 10px;
  box-shadow: 0 0 10px 0 rgba(117, 22, 206, 0.2);
}
.m_vs {
  width: 500px;
  max-width: 500px;
}
label {
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: black !important;
}
.card-warning {
  background-color: #ffb108;
  box-shadow: rgba(71, 71, 71, 0.589) 0 2px 10px;
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.form-item-section {
  background-color: $product-details-bg;
}
</style>
